import { render, staticRenderFns } from "./download-action.vue?vue&type=template&id=deb37968&scoped=true"
import script from "./download-action.vue?vue&type=script&lang=js"
export * from "./download-action.vue?vue&type=script&lang=js"
import style0 from "./download-action.vue?vue&type=style&index=0&id=deb37968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb37968",
  null
  
)

export default component.exports